import React from 'react';
import loadable from '@loadable/component';

import withPage, { loadGraphQLData } from '../page';
import CompareDrawer from '../compare/components/compare-drawer';

const CategoryLandingPage = loadable(() => import('./components'));

const CLPContainer = ({ slugInfo }) => {
    return (
        <>
            <CategoryLandingPage slugInfo={slugInfo} />
            <CompareDrawer />
        </>
    );
};

export default {
    component: withPage(CLPContainer, {
        wrapperClassName: 'clp-root',
        showWordCloud: true,
        useV2: true,
        useGraphQL: true,
    }),
    loadData: loadGraphQLData,
};
